import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { MatDialogRef } from '@angular/material/dialog';

import { IEquipment } from '@services/registrations/registrations.models';

import { DialogService } from '@services/dialog/';
import { RegistrationsService } from '@services/registrations';

import { ViewBikeDetailsComponent } from './../view-bike-details/view-bike-details.component';

@Component({
	selector: 'app-search-bike',
	templateUrl: './search-bike.component.html',
	styleUrls: ['./search-bike.component.scss']
})
export class SearchBikeComponent implements OnInit {
	public bikes: IEquipment[];
	public sortOrder = 'asc';
	public sortColumn = 'serialNumber';

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatTable) table: MatTable<any>;
	public tableColumns: string[] = ['bikeUuid', 'serialNumber', 'model', 'photoUrl', 'isRegistered'];

	formInputs = new FormGroup({
		bikeId: new FormControl('', [Validators.required])
	});

	get formIsValid(): boolean {
		return this.formInputs.valid;
	}

	constructor(
		private dialogRef: MatDialogRef<SearchBikeComponent>,
		private dialogService: DialogService,
		public registrationsService: RegistrationsService
	) { }

	ngOnInit(): void {
	}

	close(event): void {
		this.dialogRef.close();
	}

	findBikes(): void {
		this.registrationsService.bikesBySerialNumber(
			this.formInputs.controls.bikeId.value
		).subscribe((res: IEquipment[]) => {
			this.bikes = res;
		});
	}

	viewBikeDetailsUsingId(id: string): void {
		console.log('SearchBikeComponent - viewBikeDetailsUsingId: ', id);
		this.dialogService.open(ViewBikeDetailsComponent, {
			data: {
				id: id,
				callback: (requestId: string) => {
				}
			}
		});
	}

	viewBikeDetailsUsingSerialNumber(serialNumber): void {
		console.log('SearchBikeComponent - viewBikeDetailsUsingSerialNumber: ', serialNumber);
		this.dialogService.open(ViewBikeDetailsComponent, {
			data: {
				serialNumber: serialNumber,
				callback: (requestId: string) => {
				}
			}
		});
	}
}
